package org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_payment_method


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ApaleoPaymentMethods(
    @SerialName("creditCardIndexArr")
    val creditCardIndexArr: List<Int?>?,
    @SerialName("name")
    val name: String?,
    @SerialName("__typename")
    val typename: String?
)